import { defineStore } from 'pinia'

export const useUserClientConfigStore = defineStore(
  'userClientConfigStore',
  () => {
    function isDarkMode() {
      return localStorage.getItem('dark_mode') === 'true'
    }

    function setDarkMode(darkModeActive: boolean) {
      localStorage.setItem('dark_mode', darkModeActive.toString())
    }

    return {
      setDarkMode,
      isDarkMode
    }
  }
)
